import {Component, Input, OnInit, TemplateRef, ViewChild} from "@angular/core";
import {CurrencyItem} from "../../../objects/currencyExchange/currencyItem";
import {TableItem} from "../../../objects/currencyExchange/currencyTableItem";
import {CurrencyEnum} from "../../../objects/currencyExchange/currencyEnum";
/**
 * Created by alex.y on 7/20/2017.
 */
@Component({
    selector: "currency-table",
    templateUrl: "./currencyTable.component.html",
    moduleId: module.id.toString()
})
export class CurrencyTableComponent implements OnInit {
    @Input()
    public currencyItems: Array<CurrencyItem> = [];

    public tableItems: Array<TableItem<CurrencyItem>> = [];

    public columns: any = [];

    @ViewChild('editTmpl') editTmpl: TemplateRef<any>;
    @ViewChild('hdrTpl') hdrTpl: TemplateRef<any>;

    @ViewChild('editTmp2') editTmp2: TemplateRef<any>;
    @ViewChild('hdrTp2') hdrTp2: TemplateRef<any>;

    public ngOnInit(): void {
        this.initData();
    }

    private initData(): void {
        let i = 0;

        for (let item of this.currencyItems) {
            if (++i == 26)
                break;

            let items = this.currencyItems.filter(x => x.Name == item.Name).splice(0, 5);//take only first 5 elements

            this.tableItems.push(new TableItem<CurrencyItem>({
                Name: item.Name,
                Items: items
            }));
        }

        if(this.tableItems.length <= 0)
            return;

        this.columns = [{
            cellTemplate: this.editTmpl,
            headerTemplate: this.hdrTpl,
            name: 'Currency'
        }];

        for (let i = 0; i < this.tableItems[0].Items.length; i++) {
            this.columns.push({
                cellTemplate: this.editTmp2,
                headerTemplate: this.hdrTp2,
                name: this.tableItems[0].Items[i].Date,
                index: i,
            });
        }
    }

    public convertName(name: string): string {
        return String.getEnumValue(name, CurrencyEnum);
    }
}


// WEBPACK FOOTER //
// ./app/components/currencyExchange/currencyTable/currencyTable.component.ts